import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 72px;
  align-items: center;
  justify-content: center;
`
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SearchIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  padding-left: 19.4px;
`
